// extracted by mini-css-extract-plugin
export default {"HomeDataPoint":"style_HomeDataPoint__VFIho","value":"style_value__WfoDs","info":"style_info__UY4qA","highlight":"style_highlight__sGBa+","secondary":"style_secondary__HR-r-"};